import $ from 'jquery';

$(document).ready(function() {
  if (window.location.pathname === '/chekaut/') {
    // $('.gift .close-modal').on('click', (e) => {
    //   document.cookie = 'giftIsClosed=true';
    // });
    // (function checkGiftPopup() {
    //   let checkCookie = document.cookie.replace(/(?:(?:^|.*;\s*)giftIsClosed\s*\=\s*([^;]*).*$)|^.*$/, '$1');
    //
    //   if (!checkCookie) {
    //
    //     $.fancybox.open({
    //       src: '#gift',
    //       closeExisting: true,
    //       smallBtn: false,
    //       toolbar: false,
    //       touch: false,
    //       afterClose: document.cookie = 'giftIsClosed=true',
    //     });
    //   }
    // })();
  }
});
